import { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import { Button, Group } from "@mantine/core";
import { IconLogout, IconMail, IconSend, IconTemplate } from "@tabler/icons-react";

import messaging_logo from "../../assets/logo.svg";
import { KeycloakAuthenticatorContext } from "../../keycloak/KeycloakAuthenticator.tsx";
import classes from "../../styles/components/menu/SideMenu.module.scss";

const data = [
  { link: "/", icon: <IconMail />, label: "Mails" },
  { link: "/templates", icon: <IconTemplate />, label: "Templates" },
  { link: "/senders", icon: <IconSend />, label: "Senders" }
];

export function SideMenu() {
  const location = useLocation();
  const { logout } = useContext(KeycloakAuthenticatorContext);

  const findActiveLabel = () => {
    const activeItem = data.find((item) => {
      if (location.pathname === item.link) {
        return true;
      }
      return item.link === "/templates" && /^\/templates\/\d+/.test(location.pathname);
    });
    return activeItem?.label;
  };

  const [active, setActive] = useState(findActiveLabel());

  const links = data.map((item) => (
    <Link
      to={item.link}
      className={classes.link}
      data-active={item.label === active ? true : undefined}
      key={item.label}
      onClick={() => setActive(item.label)}
    >
      <span className={classes.icon}>{item.icon}</span>
      {item.label}
    </Link>
  ));

  useEffect(() => {
    setActive(findActiveLabel());
  }, [location.pathname]);

  return (
    <nav className={classes.navbar}>
      <div className={classes.navbarMain}>
        <Group className={classes.header}>
          <img className={classes.image} src={messaging_logo} alt="Messaging" />
        </Group>
        {links}
      </div>

      <div className={classes.footer}>
        <Button className={classes.logout} onClick={() => logout()}>
          <IconLogout className={classes.icon} />
          <span>Logout</span>
        </Button>
      </div>
    </nav>
  );
}
